/**
 * 
  * @param {Object=} playlist
 */
class Quality {
  constructor(representation) {
    this.selected = false;
    this.label = 'Auto';
    this.auto = true;
    this.representation = representation;
    if (representation) {
      this.bitrate = representation.bandwidth || representation.bitrate;
      this.id = Quality.getRepresentationID(representation);
      this.auto = false;

      let customLabel = representation.attrs && representation.attrs['X-TITLE'];
      let match = this.id && this.id.match(/playlist\/\S+\/\S+\/(\S+)\/\S+\/\S+/);

      if (customLabel) {
        this.label = customLabel;
      } else if (match) {
        this.label = match[1];
      } else if (representation.height) {
        this.label = representation.height + 'p';
      } else {
        this.label = (this.bitrate / 1000).toFixed()+' kbps';
      }

      let qualityName = representation.attrs && representation.attrs['X-NAME'];
      this.name = qualityName;
      this.height = representation.height;
    }
  }

  static getRepresentationID(representation) {
    let id = representation.id;
    return id || (Array.isArray(representation.url) ? representation.url[0] : representation.url);
  }

  eq(representation) {
    return representation && 
      Quality.getRepresentationID(representation) == this.id;
  }
}

export default Quality;
